<template>
  <div class="popup">
    <div class="tips">
      <div class="info">
        <h4>{{ tipHead }}</h4>
        <p>{{ tipMsg }}</p>
      </div>
      <div class="operation">
        <button @click="close">{{ cancelText ? cancelText : '取消' }}</button>
        <button @click="confirm">{{ confirmText ? confirmText : '确定' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['tipHead', 'tipMsg', 'cancelText', 'confirmText'],
  methods: {
    confirm() {
      this.$emit('confirm')
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
.popup {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  .tips {
    width: 60%;
    background: #fff;
    border-radius: 0.15rem;
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    .info {
      width: 100%;
      padding: 0.25rem;
      box-sizing: border-box;
      h4 {
        font-size: 0.4rem;
        margin: 0.2rem 0;
        color: #4d4d4d;
        width: 100%;
        text-align: center;
        font-weight: bold;
      }
      p {
        display: block;
        font-size: 0.4rem;
      }
    }
    .operation {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 0 0 0.15rem 0.15rem;
      button {
        width: 50%;
        height: 1rem;
        border: 0;
        line-height: 0.5rem;
        font-size: 0.4rem;
      }
      button:last-child {
        background: #35b6a4;
        color: #fff;
        border-radius: 0 0 0.15rem 0;
      }
      button:first-child {
        background: #f7f7f7;
        color: #35b6a4;
        border-radius: 0 0 0 0.15rem;
      }
    }
  }
}
</style>
